


<mat-tab-group>
    <mat-tab label="Address"> 
        <div class='m-3'>
            <app-address></app-address> 
        </div>
    </mat-tab>
    <mat-tab label="Connect app"> 
        <div class='m-3'>
            <app-appconnect></app-appconnect>
        </div>
    </mat-tab>
    <mat-tab label="Finished cities"> 
        <app-status>Status postcard</app-status>
    </mat-tab>
  </mat-tab-group>

